import { rootApi } from '../rootApi';
import { HTTPRequestType } from '../api.types';

export type ColumnListKey = 'candidates' | 'contacts' | 'companies';

/** One stored column in a user's list preference: which field, whether shown, and its order. */
export interface ColumnPreference {
  key: string;
  visible: boolean;
}

interface ColumnPreferencesResponse {
  list: ColumnListKey;
  columns: ColumnPreference[] | null;
}

/**
 * Per-user list column preferences (JT1-1527/1528). Self-scoped under /accounts/my so a user
 * always reads/writes their own. Cached per list via the ColumnPreferences tag.
 */
const columnPreferencesService = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getColumnPreferences: builder.query<ColumnPreferencesResponse, ColumnListKey>({
      query: (list) => ({
        url: `/accounts/my/column-preferences`,
        params: { list },
      }),
      providesTags: (_result, _error, list) => [{ type: 'ColumnPreferences', id: list }],
    }),

    updateColumnPreferences: builder.mutation<ColumnPreferencesResponse, { list: ColumnListKey; columns: ColumnPreference[] }>({
      query: (data) => ({
        url: `/accounts/my/column-preferences`,
        method: HTTPRequestType.PUT,
        data,
      }),
      invalidatesTags: (_result, _error, { list }) => [{ type: 'ColumnPreferences', id: list }],
    }),
  }),
});

export const { useGetColumnPreferencesQuery, useUpdateColumnPreferencesMutation } = columnPreferencesService;
